// type
export const pressCenterFilterTypeKeys = {
  smi: 'smi',
  press: 'press',
};

export const pressCenterFilterTypesData = {
  [pressCenterFilterTypeKeys.smi]: {
    key: pressCenterFilterTypeKeys.smi,
    queryKey: pressCenterFilterTypeKeys.smi,
    sendKey: 1,
  },
  [pressCenterFilterTypeKeys.press]: {
    key: pressCenterFilterTypeKeys.press,
    queryKey: pressCenterFilterTypeKeys.press,
    sendKey: 2,
  },
};
export const pressCenterFilterTypesDataValues = Object.values(
  pressCenterFilterTypesData,
);

// filters
export const pressCenterFilterKeys = {
  type: 'type',
};

export const pressCenterFilterData = {
  [pressCenterFilterKeys.type]: {
    key: pressCenterFilterKeys.type,
    initialValue: null,
  },
};
export const pressCenterFilterDataValues = Object.values(pressCenterFilterData);
